import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useState } from 'react';

import { useAuth } from "../Login/AuthProvider";
import { ProtectedRoute } from "./ProtectedRoute";
import Login from "../Login/Login";
import Logout from "../Login/Logout";
import ForgotPassword from "../Login/ForgotPassword";
import ResetPassword from "../Login/ResetPassword";
import SessionExpired from "../Login/SessionExpired";
import ActivateEmail from "../Login/ActivateEmail";
import PageLayout from "../Pages/PageLayout";
import PageTemplates from "../Pages/PageTemplates";
import PageSnippets from "../Pages/PageSnippets";
import PageContentSourcesOld from "../Pages/PageContentSourcesOld";
import PageContentSources from "../Pages/PageContentSources";
import PageApollodorus from "../Pages/PageApollodorus";
import PageDataFunctions from "../Pages/PageDataFunctions";
import PageAdminUsers from  "../Pages/PageAdminUsers";
import PageAdminPacing from "../Pages/PageAdminPacing";
import PageImpersonate from "../Pages/PageImpesonate";
import PageAdminInvoices from "../Pages/PageAdminInvoices";
import PageAdminColors from "../Pages/PageAdminColors";
import PageAdminFonts from "../Pages/PageAdminFonts";
import PageAdminSettings from "../Pages/PageAdminSettings";
import PageAdminArchive from "../Pages/PageAdminArchive";
import PageAdminUpdatePaymentConfirm from "../Pages/PageAdminUpdatePaymentConfirm";
import PageActivateLogin from  "../Pages/PageActivateLogin";
import PageEditTemplate from "../Pages/PageEditTemplate";
import PageTimerFromTemplate from "../Pages/PageTimerFromTemplate";
import PageTextImageFromTemplate from "../Pages/PageTextImageFromTemplate";
import PageGeneratorFromTemplate from "../Pages/PageGeneratorFromTemplate";
import PagePersAnimationsFromTemplate from "../Pages/PagePersAnimationsFromTemplate";
import PageGeneratorFromContentSource from "../Pages/PageGeneratorFromContentSource";
import PageVotesFromTemplate from "../Pages/PageVotesFromTemplate";
import PageMoodMeterFromTemplate from "../Pages/PageMoodMeterFromTemplate";
import PageClickCounterFromTemplate from "../Pages/PageClickCounterFromTemplate";
import PageForecastsFromTemplate from "../Pages/PageForecastsFromTemplate";

import TimerWizard from "../Wizards/timerWizard";
import TextImageWizard from "../Wizards/textImagesWizard";
import GeneratorWizard from "../Wizards/generatorWizard";
import VotesWizard from "../Wizards/votesWizard";
import OSTrackerWizard from "../Wizards/osTrackerWizard";
import PersAnimationsWizard from "../Wizards/persAnimationsWizard";
import ScratchWinWizard from "../Wizards/scratchWinWizard";
import SpinningWheelWinWizard from "../Wizards/spinningWheelWizard";
import ForecastsWizard from "../Wizards/forecastsWizard";
import TimedImagesWizard from "../Wizards/timedImagesWizard";
import SlidingPuzzleWizard from "../Wizards/slidingPuzzleWizard";
import ChartsWizard from "../Wizards/chartsWizard";
import BarcodesWizard from "../Wizards/barcodesWizard";

import TimerWorkflow from "../workflows/timerWorkflow";
import TextImagesWorkflow from "../workflows/textImagesWorkflow";
import GeneratorWorkFlow from "../workflows/generatorWorkflow";
import VariantsViewerWorkFlow from "../workflows/variantsViewerWorkflow";
import VotesWorkflow from "../workflows/votesWorkflow";
import MoodMeterWorkflow from "../workflows/moodmeterWorkflow";
import ClickCounterWorkflow from "../workflows/clickcounterWorkflow";
import OSTrackerWorkflow from "../workflows/osTrackerWorkflow";
import PersAnimationsWorkflow from "../workflows/persAnimationsWorkflow";
import ScratchWinWorkflow from "../workflows/scratchWinWorkflow";
import SpinningWheelWorkflow from "../workflows/spinningWheelWorkflow";
import ForecastsWorkFlow from "../workflows/forecastsWorkflow";
import TimedImagesWorkflow from "../workflows/timedImagesWorkflow";
import SlidingPuzzleWorkflow from "../workflows/slidingPuzzleWorkflow";
import MemoryCardsWorkflow from "../workflows/memoryCardsWorkflow";
import ChartWorkflow from "../workflows/chartsWorkflow";
import BarcodeWorkflow from "../workflows/barcodesWorkflow";
import ImgOptimiserWorkflow from "../workflows/imgOptimiserWorkflow";
import GuessWordWorkflow from "../workflows/guessWordWorkflow";
import OfferBrokerWorkflow from "../workflows/offerBrokerWorkflow";
import ConditionsManagerWorkflow from "../workflows/conditionsManagerWorkflow";
import NearestStoreWorkFlow from "../workflows/nearestStoreWorkflow";

import ProductHomeTimers from "../Pages/ProductsHomes/ProductHomeTimers";
import ProductHomeTextImages from "../Pages/ProductsHomes/ProductHomeTextImages";
import ProductHomeContentAutomation from "../Pages/ProductsHomes/ProductHomeContentAutomation";
import ProductHomeVariantsViewer from "../Pages/ProductsHomes/ProductHomeVariantsViewer";
import ProductHomeVotes from "../Pages/ProductsHomes/ProductHomeVotes";
import ProductHomeMoodMeter from "../Pages/ProductsHomes/ProductHomeMoodMeter";
import ProductHomeClickCounter from "../Pages/ProductsHomes/ProductHomeClickCounter";
import ProductHomeOSTracker from "../Pages/ProductsHomes/ProductHomeOSTracker";
import ProductHomePersAnimation from "../Pages/ProductsHomes/ProductHomePersAnimation";
import ProductHomeScratchWin from "../Pages/ProductsHomes/ProductHomeScratchWin";
import ProductHomeSpinningWheel from "../Pages/ProductsHomes/ProductHomeSpinningWheel";
import ProductHomeWeatherForecasts from "../Pages/ProductsHomes/ProductHomeWeatherForecasts";
import ProductHomeTimedImages from "../Pages/ProductsHomes/ProductHomeTimedImages";
import ProductHomeSlidingPuzzle from "../Pages/ProductsHomes/ProductHomeSlidingPuzzle";
import ProductHomeMemoryCards from "../Pages/ProductsHomes/ProductHomeMemoryCards";
import ProductHomeCharts from "../Pages/ProductsHomes/ProductHomeCharts";
import ProductHomeBarcodes from "../Pages/ProductsHomes/ProductHomeBarcodes";
import ProductHomeImgOptimiser from "../Pages/ProductsHomes/ProductHomeImgOptimiser";
import ProductHomeGuessWord from "../Pages/ProductsHomes/ProductHomeGuessWord";
import ProductHomeOfferBroker from "../Pages/ProductsHomes/ProductHomeOfferBroker";
import ProductHomeConditionsManager from "../Pages/ProductsHomes/ProductHomeConditionsManager";
import ProductHomeNearestStore from "../Pages/ProductsHomes/ProductHomeNearestStore";

import ReportDashboard from "../Reports/reportDashboard";
import SnippetScratchOffReport from "../Reports/snippetScratchOffReport";
import SnippetPollReport from "../Reports/snippetPollReport";
import SnippetSpinningWheelReport from "../Reports/snippetSpinningWheelReport";
import SnippetTimedImagesReport from "../Reports/snippetTimedImagesReport";
import SnippetSlidingPuzzleReport from "../Reports/snippetSlidingPuzzleReport";
import SnippetImageOptimiserReport from "../Reports/snippetImageOptimiserReport";
import SnippetMemoryCardsReport from "../Reports/snippetMemoryCardsReport";
import SnippetChartReport from "../Reports/snippetChartReport";
import SnippetTimerReport from "../Reports/snippetTimerReport";
import SnippetGuessTheWordReport from "../Reports/snippetGuessWordReport";
import SnippetOfferBrokerReport from "../Reports/snippetOfferBrokerReport";
import SnippetRuleBuilderReport from "../Reports/snippetRuleBuilderReport";
import SnippetNearestStoreReport from "../Reports/snippetNearestStoreReport";

import PageCatalogCustomColumns from "../Pages/PageCatalogCustomColumns";

import { NewUserWorkflow } from "../Stripe/newUserWorkflow";
import { NewUserWorkflow2 } from "../Stripe/newUserWorkflow2";
import { PageSubscriptionResult } from "../Stripe/PageSubscriptionResult";

import Button from '@mui/material/Button';
import HomeComponent from "../components/HomeComponent";
import SettingsContextProvider from '../components/userSettingsContext'


const Routes = () => {
  const { token } = useAuth();
  const [settings, setSettings] = useState({enabledProductIds: []});

  // Define public routes accessible to all users
  const routesForPublic = [
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/login/:dest",
      element: <Login />,
    },
    {
      path: "/forgotPassword",
      element: <ForgotPassword />,
    },
    {
      path: "/resetPassword/:code1/:code2",
      element: <ResetPassword />,
    },
    {
      path: "/activateEmail/:code1/:code2",
      element: <ActivateEmail />,
    },
    {
      path: "/service",
      element: <div>Service Page<Button variant="contained">Ciao</Button></div>,
    },
    {
      path: "/about-us",
      element: <div>About Us</div>,
    },
    {
      path: "/stripe",
      children: [
        {
          path: "newUser",
          element:<NewUserWorkflow />,
        },
        {
          path: "newUser2",
          element:<NewUserWorkflow2 />,
        },
        {
          path: "subscriptionResult",
          element:<PageSubscriptionResult />,
        },
      ]
    },
  ];

  // Define routes accessible only to authenticated users
  const routesForAuthenticatedOnly = [
    {
      path: "/",
      element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
      children: [
        {
          path: "/",
          element:  <SettingsContextProvider settings={settings} setSettings={setSettings}>
          <PageLayout selectedPage='home' enableIntroJsTour ><HomeComponent /></PageLayout></SettingsContextProvider>,
        },
        {
          path: "impersonate",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><PageImpersonate /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/admin",
          children: [
            {
              path: "users",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageAdminUsers /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "subscription-center",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageAdminInvoices /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "pacing",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageAdminPacing /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "colors",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageAdminColors /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "fonts",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageAdminFonts /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "settings",
              element:  <SettingsContextProvider settings={settings} setSettings={setSettings}>
                        <PageLayout ><PageAdminSettings /></PageLayout>
                        </SettingsContextProvider>,
            },
            {
              path: "archive",
              element:  <SettingsContextProvider settings={settings} setSettings={setSettings}>
                        <PageLayout ><PageAdminArchive /></PageLayout>
                        </SettingsContextProvider>,
            },
            {
              path: "updatepayment",
              element:  <SettingsContextProvider settings={settings} setSettings={setSettings}>
                        <PageLayout ><PageAdminUpdatePaymentConfirm /></PageLayout>
                        </SettingsContextProvider>,
            },
        
          ]
        },
        {
          path: "/ph",
          children: [
            {
              path: "timers",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeTimers /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "timersFromTemplate/:templateId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageTimerFromTemplate /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "textImages",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeTextImages /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "textImagesFromTemplate/:templateId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageTextImageFromTemplate /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "generator",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeContentAutomation /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "variantsViewer",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeVariantsViewer /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "generatorFromTemplate/:templateId/:dataConnectionId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageGeneratorFromTemplate /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "generatorFromContentSource/:dataConnectionId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageGeneratorFromContentSource /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "votes",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeVotes /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "votesFromTemplate/:templateId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageVotesFromTemplate /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "moodmeter",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeMoodMeter /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "moodmeterFromTemplate/:templateId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageMoodMeterFromTemplate /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "clickcounter",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeClickCounter /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "clickcounterFromTemplate/:templateId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageClickCounterFromTemplate /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "appMatch",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeOSTracker /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "persAnimation",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomePersAnimation /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "persAnimationsFromTemplate/:templateId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PagePersAnimationsFromTemplate /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "scratch",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeScratchWin /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "spinning",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeSpinningWheel /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "forecasts",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeWeatherForecasts /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "forecastsFromTemplate/:templateId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PageForecastsFromTemplate /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "timedImages",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeTimedImages /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "slidingPuzzle",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeSlidingPuzzle /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "memoryCards",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeMemoryCards /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "charts",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeCharts /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "barcodes",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeBarcodes /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "imgOptimiser",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeImgOptimiser /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "guessWord",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeGuessWord /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "offerBroker",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeOfferBroker /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "conditionsManager",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeConditionsManager /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "nearestStore",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ProductHomeNearestStore /></PageLayout>
                      </SettingsContextProvider>,
            },
          ]
        },
        {
          path: "/workflow",
          children: [
            {
              path: "12",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><TimerWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "9",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><TextImagesWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "1",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><GeneratorWorkFlow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "21",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><VariantsViewerWorkFlow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "21/:snippetId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><VariantsViewerWorkFlow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "5",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><VotesWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "6",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ClickCounterWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "7",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><MoodMeterWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "13",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><OSTrackerWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "14",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><PersAnimationsWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "15",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ScratchWinWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "16",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><SpinningWheelWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "18",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ForecastsWorkFlow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "19",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><TimedImagesWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "20",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><SlidingPuzzleWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "22",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><MemoryCardsWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "22/:snippetId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><MemoryCardsWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "23",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ChartWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "8",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><BarcodeWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "24",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ImgOptimiserWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "24/:snippetId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ImgOptimiserWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "25",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><GuessWordWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "25/:snippetId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><GuessWordWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "26",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><OfferBrokerWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "26/:snippetId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><OfferBrokerWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "27",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ConditionsManagerWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "27/:snippetId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><ConditionsManagerWorkflow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "28",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><NearestStoreWorkFlow /></PageLayout>
                      </SettingsContextProvider>,
            },
            {
              path: "28/:snippetId",
              element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                      <PageLayout ><NearestStoreWorkFlow /></PageLayout>
                      </SettingsContextProvider>,
            },
          ]
        },
        {
          path: "/members/subscriptionResult",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout><PageSubscriptionResult member /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/templates",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='templates' ><PageTemplates /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/templates/edit/:snippetTypeId/:templateId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout ><PageEditTemplate /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/elements",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='elements' ><PageSnippets /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/contentsourcesOld",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='contentsources' ><PageContentSourcesOld /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/contentsources",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='contentsources' ><PageContentSources /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/datafunctions",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='datafunctions' ><PageDataFunctions /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/apollodorus",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='apollodorus' ><PageApollodorus /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/timers/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><TimerWizard /*snippetId={params.id}*/ /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/textImages/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><TextImageWizard /*snippetId={params.id}*/ /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/generator/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><GeneratorWizard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/votes/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><VotesWizard snippetTypeId={5} /*snippetId={params.id}*/ /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/moodmeter/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><VotesWizard snippetTypeId={7} /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/clickcounter/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><VotesWizard snippetTypeId={6} /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/appMatch/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><OSTrackerWizard /*snippetId={params.id}*/ /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/persAnimations/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><PersAnimationsWizard /*snippetId={params.id}*/ /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/scratch/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><ScratchWinWizard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/spinningwheel/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><SpinningWheelWinWizard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/forecasts/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><ForecastsWizard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/timedimages/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><TimedImagesWizard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/slidingPuzzle/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><SlidingPuzzleWizard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/charts/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><ChartsWizard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/barcodes/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='snippets' ><BarcodesWizard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/reports",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                    <PageLayout selectedPage='reports' ><ReportDashboard /></PageLayout>
                    </SettingsContextProvider>,
        },
        {
          path: "/reports/element/15/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetScratchOffReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/16/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetSpinningWheelReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/5/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetPollReport snippetTypeId={5} /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/6/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetPollReport snippetTypeId={6} /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/7/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetPollReport snippetTypeId={7} /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/12/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetTimerReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/19/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetTimedImagesReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/20/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetSlidingPuzzleReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/22/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetMemoryCardsReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/23/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetChartReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/24/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetImageOptimiserReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/25/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetGuessTheWordReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/26/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetOfferBrokerReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/27/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetRuleBuilderReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/reports/element/28/:snippetId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><SnippetNearestStoreReport /></PageLayout>
                  </SettingsContextProvider>,
        },
        {
          path: "/catalogs/customColumns/:catalogId",
          element: <SettingsContextProvider settings={settings} setSettings={setSettings}>
                  <PageLayout ><PageCatalogCustomColumns /></PageLayout>
                  </SettingsContextProvider>,
        },

        {
          path: "/profile",
          element: <PageLayout >User profile</PageLayout>,
        },
        {
          path: "/logout",
          element: <Logout />,
        },
        {
          path: "/sessionexpired",
          element: <SessionExpired />,
        },
      ],
    },
  ];

  // Define routes accessible only to non-authenticated users
  const routesForNotAuthenticatedOnly = [
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/activateLogin",
      element: <PageActivateLogin />,
    },
  ];

  // Combine and conditionally include routes based on authentication status
  const router = createBrowserRouter([
    ...routesForPublic,
    ...(!token ? routesForNotAuthenticatedOnly : []),
    ...routesForAuthenticatedOnly,
  ]);

  // Provide the router configuration using RouterProvider
  return <RouterProvider router={router} />;
};

export default Routes;

